import { axiosSwagger } from "@/axios";



export const state = {
  currentChildFile: {
    loading: false,
    data: [],

    selectedID: null,

    isMultiple: false,
    multipleSelectedID: [],
  },
  pagination: {
    grid: {
      start: 0,
      limit: 9,
    },
    table: {
      start: 0,
      limit: 10,
    },
    list: {
      start: 0,
      limit: 9,
    }
  },
  // for pin changes
  pin: {
    data: {},
  },

  streamFileProgress: 0,

  uploadPercentage: null,
  downloadPercentage: null,
}


export const getters = {
}


export const mutations = {
  // CURRENT FILE
  currentChildFileLoading: (state, loading) => {
    state.currentChildFile.loading = loading;
  },
  setCurrentChildFileData: (state, data) => {
    state.currentChildFile.data = modifyData( data );
  },
  removeFile: (state, id) => {
    state.currentChildFile.data = state.currentChildFile.data.filter(
      (el) => el.id !== id
    );
  },
  updateFileLocation: (state, { fileIds, selectedLocation }) => {
    let fileData = state.currentChildFile.data;

    fileIds.forEach(id => {
      const index = fileData.findIndex((item) => item.id == id);
  
      if (index !== -1) {
          // location
          fileData[index].fileLocationId = selectedLocation.id;
  
          fileData[index].fileLocation = selectedLocation;
      }
    });
    
  },
  selectFileID: (state, id) => {
    // remove ang folder selected id
    // state.currentChildFolder.selectedID = null;

    // set ang file selected id
    state.currentChildFile.selectedID = id;
  },
  updatePinFile: (state, data) => {
    let fileData = state.currentChildFile.data;
    
    const index = fileData.findIndex((item) => item.id === data.id);

    if (index !== -1) {
        fileData[index].isPinned = !fileData[index].isPinned;

        // update pin data for changes sa ui lang sa file-maanger (default)
        state.pin.data = data;
    }
  },
  fileUploadProgress: (state, data) => {
    state.uploadPercentage = data;
  },
  fileDownloadProgress: (state, data) => {
    state.downloadPercentage = data;
  },
  // multiple
  setIsMultiple: (state, boolean) => {
    state.currentChildFile.isMultiple = boolean;
  },
  setSingleMultipleID: (state, id) => {
    state.currentChildFile.multipleSelectedID = [id];
  },
  selectMultipleID: (state, id) => {
    // toggle multiple select
    if(!state.currentChildFile.multipleSelectedID?.includes(id)){
      state.currentChildFile.multipleSelectedID.push(id);
    }
    else{
      state.currentChildFile.multipleSelectedID = state.currentChildFile.multipleSelectedID.filter(
        (el) => el !== id
      );
    }
  },
  // eslint-disable-next-line no-unused-vars
  removeAllMultipleSelectID: (state, data) => {
    state.currentChildFile.multipleSelectedID = [];
  },
  setAllMultipleSelectID: (state, data) => {
    if(data?.length ?? false){
      data.forEach(e => {
        if(!state.currentChildFile.multipleSelectedID?.includes(e.id)){
          state.currentChildFile.multipleSelectedID.push(e.id);
        }
      });
    }
  },
  removeSelectedMultipleSelectID: (state, data) => {
    if(data?.length ?? false){
      let _arrIds = data.map(e => e.id);
      
      state.currentChildFile.multipleSelectedID = state.currentChildFile.multipleSelectedID.filter(
        (el) => !_arrIds.includes(el)
      );
    }
  },
  // pagination GRID
  setPaginationGridStart: (state, data) => {
    state.pagination.grid.start = data;
  },
  setPaginationGridLimit: (state, data) => {
    state.pagination.grid.limit = data;
  },
  // pagination TABLE
  setPaginationTableStart: (state, data) => {
    state.pagination.table.start = data;
  },
  setPaginationTableLimit: (state, data) => {
    state.pagination.table.limit = data;
  },
  // pagination LIST
  setPaginationListStart: (state, data) => {
    state.pagination.list.start = data;
  },
  setPaginationListLimit: (state, data) => {
    state.pagination.list.limit = data;
  },
  // remove multiple file
  removeMultipleFile: (state, dataArr) => {
    state.currentChildFile.data = state.currentChildFile.data.filter(
      (el) => !dataArr?.includes(el.id)
    );
  },
  // stream file
  setStreamFileProgress: (state, data) => {
    state.streamFileProgress = data;
  },
}


export const actions = {
  // FILE
  // eslint-disable-next-line no-unused-vars
  async readFileById({ commit }, obj) {
    return await axiosSwagger
    .get(`/api/FileManager/${obj.id}`)
    .then((response) => {

      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async readFileByCategoryId({ commit }, id) {
    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
    .get(`/api/FileManager/Category/${id}/${userData?.deliveryUnit?.id}`)
    .then((response) => {

      return response;
    });
  },
  async readFileByParentId({ commit }, obj) {
    obj.isLoad ? commit("currentChildFileLoading", true) : "";

    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

    return await axiosSwagger
    .get(`/api/FileManager/Simple/Folder/${obj.id}/${userData?.deliveryUnit?.id}`)
    .then((response) => {
      commit("setCurrentChildFileData", response.data);
      obj.isLoad ? commit("currentChildFileLoading", false) : "";

      return response;
    })
    .catch(() => {
      obj.isLoad ? commit("currentChildFileLoading", false) : "";
    });
  },
  // eslint-disable-next-line no-unused-vars
  async createFileData({ commit }, data) {
    return await axiosSwagger
    .post("/api/FileManager/Create", data)
    .then((response) => {
      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async createFileUpload({ commit }, data) {
    return await axiosSwagger
    .post("/api/FileManagerFile/Upload", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: function  (progressEvent) {
        commit("fileUploadProgress", parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) ));
      }.bind(this)
    })
    .then((response) => {
      commit("fileUploadProgress", null);
      return response;
    });
  },
  // PUT TRASH FILE
  async trashFile({ commit }, id) {
    return await axiosSwagger
    .put(`/api/FileManager/Trash/${id}`)
    .then((response) => {
        commit("removeFile", id);

        return response;
    });
  },
  async multipleTrashFile({ commit }, data) {
    return await axiosSwagger
    .post(`/api/FileManager/Trash`, data)
    .then((response) => {
        commit("removeMultipleFile", data.map(e => e.id));

        return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async updateFile({ commit }, data) {
    return await axiosSwagger
    .put(`/api/FileManager/Update/${data.id}`, data)
    .then((response) => {
        return response;
    });
  },
  // UPDATE PIN FILE
  async updatePinFile({ commit }, data) {
    return await axiosSwagger
    .put(`/api/FileManager/Pin/${data.id}`)
    .then((response) => {
      commit('updatePinFile', data);

      return response;
    });
  },
  // UPDATE UNPIN FILE
  async updateUnPinFile({ commit }, data) {
    return await axiosSwagger
    .put(`/api/FileManager/UnPin/${data.id}`)
    .then((response) => {
      commit("updatePinFile", data);

      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async getPrivateBlobByFileId({ commit }, id) {
    return await axiosSwagger
    .get(`/api/FileManagerFile/ReadFile/Stream/${id}`, { 
      responseType: "blob",
      onDownloadProgress: function  (progressEvent) {
        commit("fileDownloadProgress", parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) ));
      }.bind(this) 
    })
    .then(async (response) => {
      commit("fileDownloadProgress", null);
      return await URL.createObjectURL(response.data);
    })
  },
  // eslint-disable-next-line no-unused-vars
  async getPublicBlobByFileId({ commit }, id) {
    return await axiosSwagger
    .get(`/api/FileManagerFile/ReadFile/Public/${id}`, { 
      responseType: "blob",
      onDownloadProgress: function  (progressEvent) {
        commit("fileDownloadProgress", parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) ));
      }.bind(this) 
    })
    .then(async (response) => {
      commit("fileDownloadProgress", null);
      return await URL.createObjectURL(response.data);
    })
  },
  // eslint-disable-next-line no-unused-vars
  async updateMultipleFilesToLocation({ commit }, data){
    return await axiosSwagger
    .post("/api/FileManager/PhysicalLocation/Move", data)
    .then((response) => {
      return response;
    });
  },
  // eslint-disable-next-line no-unused-vars
  async deleteFileManagerFile({ commit }, id){
    return await axiosSwagger
    .delete(`/api/FileManagerFile/Delete/${id}`)
    .then((response) => {
      return response;
    });
  },
  
}

// async function blobToBase64(blob) {
//   // eslint-disable-next-line no-unused-vars
//   return new Promise((resolve, _) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.readAsDataURL(blob);
//   });
// }


const checkIsClassified = (e) => {
  if(e ?? false){
    // e filter data if classified and if user is not the one who upload
    const isClassified = e?.isClassified ? e.isClassified : ((e.filePostings?.length ?? false) ? e.filePostings.find(x => x.fileManagerId === e.id).isClassified : false);
    const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
    
    return isClassified && e.applicationUserId !== userData?.userId && e?.status?.toLowerCase() === "approved";
  }
}

// modify data for file posting status
const modifyData = (arrayData) => {
  if(arrayData?.length ?? false){
    arrayData.forEach(e => {
      e.status = e?.status ? (e.status?.toLowerCase() ?? "") : ((e.filePostings?.length ?? false) ? e.filePostings.find(x => x.fileManagerId === e.id).status.toLowerCase() : '');

      e.isClassifiedDoc = checkIsClassified(e);
    });

    
    return arrayData
  }

  return [];
};
